import { render, staticRenderFns } from "./ReleasePaymentConfirmationModal.vue?vue&type=template&id=1b830eab&"
import script from "./ReleasePaymentConfirmationModal.vue?vue&type=script&lang=js&"
export * from "./ReleasePaymentConfirmationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports